module.exports = __webpack_public_path__ + "static/media/shema-dark@3x-En.091d26e4.png";